import { Link } from "react-router-dom";


function MenuFunction() { // .classList.contains('my-class')

    let navBar = document.querySelector(".navBar");
    let menuIcon = document.getElementById('menuIcon');
    
       if (navBar.style.display === "block") {
             navBar.style.display = "none";
          document.getElementById("menu").style.paddingLeft = "0px";
          menuIcon.classList.remove('fa-minus');
          menuIcon.classList.add('fa-caret-down');
          // document.getElementById("menu").style.color = "#d6b289";
           } else {
           navBar.style.display = "block";
          document.getElementById("menu").style.paddingLeft = "4px";
          menuIcon.classList.remove('fa-caret-down');
          menuIcon.classList.add('fa-minus');
          // document.getElementById("menu").style.color = "#d6b289";
       }
  };


  function clearMenuFunction(){
    let navBar = document.querySelector(".navBar");
    let menuIcon = document.getElementById('menuIcon');
      if(navBar.style.display === "block") {
        navBar.style.display = "none";
          document.getElementById("menu").style.paddingLeft = "0px";
          menuIcon.classList.remove('fa-minus');
          menuIcon.classList.add('fa-caret-down');
      }
  }

  function subFunction() {
  	let subdrpdwn = document.querySelector(".subDrop");
    let subIcon = document.getElementById("subIcon");
 	
	if (subdrpdwn.style.display === "block") {
   		subdrpdwn.style.display = "none";
		subIcon.classList.remove('fa-minus');
    subIcon.classList.add('fa-caret-down');
		subIcon.classList.add('downArrowSpace');
		
	} else {
 		subdrpdwn.style.display = "block";
		subIcon.classList.remove('fa-caret-down');
    subIcon.classList.add('fa-minus');
		subIcon.classList.remove('downArrowSpace');
 	}
};

  function doubleClear(){
    subFunction();
    clearMenuFunction();
  }

  // function Nav() {
  //   return (
  //       <nav>
  //   	<ul>
  //   <li><button id="menu" className="navText" onClick={menuFunction} title="Menu">Menu <i id="menuIcon" className="fa-solid fa-caret-down"></i></button>
  //   	<ul className="navBar">
  //         <li><Link to="/Podcasts" title="Podcasts" className="navText link">Podcasts</Link></li>
  //      		<li><Link to="/Transcripts" title="Transcripts" className="navText link">Transcripts</Link></li>
  //      		<li><Link to="/Resources" title="Resources" className="navText link">Resources</Link></li>
  //         <li><a href="mailto:truelibertynorth@gmail.com" title="Email: TrueLibertyNorth@gmail.com" target="_self" className="navText subMenu">Contact</a></li>
  //    	</ul>
  //   </li>
  //   </ul>
  // 	</nav>
  //   );
  // };
    function Nav() {
     
    
    return (
        <nav>
    	<ul>
    <li><button id="menu" className="navText" onClick={MenuFunction} title="Menu">Menu <i id="menuIcon" className="fa-solid fa-caret-down"></i></button>
    	<ul className="navBar">
          <li><Link to="/Podcasts" title="Podcasts" className="navText link" onClick={clearMenuFunction}>Podcasts</Link></li>
       		<li><Link to="/Transcripts" title="Transcripts" className="navText link" onClick={clearMenuFunction}>Transcripts</Link></li>
       		<li><button id="resourceSub" className="navText" onClick={subFunction} title="subMenu"><span id="subMenuText">Resources </span><i id="subIcon" className="fa-solid fa-caret-down downArrowSpace"></i></button>
       			<ul className="subDrop">
               	 	<li><Link to="/GreatQuotes" title="Great Quotes" onClick={doubleClear} className="navText link subMenu">Great Quotes</Link></li>
                	<li><Link to="/MediaLinks" title="Media Links" onClick={doubleClear} className="navText link subMenu">Media Links</Link></li>
       			</ul>
         	</li>
          <li><a href="mailto:truelibertynorth@gmail.com" title="Email: TrueLibertyNorth@gmail.com" target="_self" className="navText subMenu">Contact</a></li>
     	</ul>
    </li>
    </ul>
  	</nav>
    );
  };


  export default Nav;